import { IActivityItemDto } from "src/types/activities";

export const isLoadingActivity = (activity: IActivityItemDto) =>
  activity.status === "pending" || activity.status === "running";
